import React from "react";
import {
    BoxIsolatedContent,
    FlexColumn,
    FlexColumnCentered,
    FormGoBack,
    NoAccessContent
} from "../../../components/ui/Content";
import {Body1, Body1Pointer, LeftText, MailLink, FormTitle} from "../../../components/Font";

import {GoBack} from "../../../icon/Icon";
import {RecoveryStepEnum} from "../../../enum/auth";
import {useTheme} from "styled-components";
import {useTranslation} from "react-i18next";
import {useAppDispatch} from "../../../app/hooks";
import {setRecoveryStep} from "../slice";
import {useLocation, useNavigate} from "react-router-dom";

export const NoAccountAccess = () => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const {search} = useLocation()
    const Theme = useTheme()

    return <FlexColumnCentered className={'box-isolated'}>
        <BoxIsolatedContent>
            <FlexColumn style={{width: '100%'}}>
                <FlexColumnCentered>
                    <FormGoBack onClick={() => dispatch(setRecoveryStep(RecoveryStepEnum.Recovery))}>
                        <GoBack/>
                    </FormGoBack>
                    <FormTitle>{t('auth.noAccess')}</FormTitle>
                </FlexColumnCentered>
                <NoAccessContent>
                    <Body1 style={{textAlign: 'center', display: 'inline'}}>
                        {`Напишите, пожалуйста, в поддержку `}
                        <MailLink href={`mailto:${t('auth.accountHelp2')}`} color={Theme.color.indicator}>
                            {t('auth.accountHelp2')}
                        </MailLink>
                        {t('auth.accountHelp3')}
                        <Body1Pointer style={{display: 'inline'}}
                                      color={Theme.color.indicator}
                                      onClick={() => {
                                          navigate(`/sign-up${search}`)
                                      }}>
                            {t('auth.accountHelp4')}
                        </Body1Pointer>
                    </Body1>
                    <LeftText>
                        После подтверждения аккаунта все ваши данные будут восстановлены.
                    </LeftText>
                </NoAccessContent>
            </FlexColumn>
        </BoxIsolatedContent>
    </FlexColumnCentered>
}
